export default "__VITE_ASSET__BqgPlHGB__"